import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export async function exportToExcel_v1(data, columns, fileName = 'tabla_exportada') {
  if (!data || !data.length) return;

  const exportableColumns = columns.filter(
    col =>
      (col.accessorKey || col.accessorFn) &&
      col.header?.toString().trim() !== '' &&
      col.accessorKey !== 'foto'
  );

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Datos');

  worksheet.columns = exportableColumns.map(col => ({
    header: typeof col.header === 'string' ? col.header : col.accessorKey,
    key: col.accessorKey || col.header,
    width: 20, 
  }));

  const headerRow = worksheet.getRow(1);
  headerRow.eachCell(cell => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF0000FF' },
    };
    cell.font = {
      color: { argb: 'FFFFFFFF' },
      bold: true,
    };
    cell.alignment = { horizontal: 'center' };
  });

  data.forEach(row => {
    const rowData = {};
    exportableColumns.forEach(col => {
      rowData[col.accessorKey || col.header] = col.accessorFn
        ? col.accessorFn(row)
        : row[col.accessorKey];
    });
    worksheet.addRow(rowData);
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  saveAs(blob, `${fileName}.xlsx`);
}

export async function exportToExcel_v2(data, columns, fileName = 'tabla_exportada') {
  if (!data || !data.length) return;

  const exportableColumns = columns.filter(
    col =>
      (col.accessorKey || col.accessorFn) &&
      col.accessorKey !== 'foto'
  );

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Datos');

  worksheet.columns = exportableColumns.map(col => ({
    header: typeof col.header === 'string' ? col.header : col.accessorKey,
    key: col.accessorKey,
    width: 20,
  }));

  const headerRow = worksheet.getRow(1);
  headerRow.eachCell(cell => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF0000FF' },
    };
    cell.font = {
      color: { argb: 'FFFFFFFF' }, 
      bold: true,
    };
    cell.alignment = { horizontal: 'center' };
  });

  data.forEach(row => {
    const rowData = {};
    exportableColumns.forEach(col => {
      rowData[col.accessorKey] = col.accessorFn
        ? col.accessorFn(row)
        : row[col.accessorKey];
    });
    worksheet.addRow(rowData);
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  saveAs(blob, `${fileName}.xlsx`);
}

export async function exportToExcel_v3(data, columns, fileName = 'tabla_exportada') {
  if (!data || !data.length) return;

  const exportableColumns = columns.filter(
    col =>
      (col.accessorKey || col.accessorFn) &&
      col.header?.toString().trim() !== '' &&
      col.accessorKey !== 'foto'
  );

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Datos');

  worksheet.columns = exportableColumns.map(col => ({
    header: typeof col.header === 'string' ? col.header : col.accessorKey || col.id,
    key: col.accessorKey || col.id, // 👈 clave única
    width: 20,
  }));

  const headerRow = worksheet.getRow(1);
  headerRow.eachCell(cell => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF0000FF' },
    };
    cell.font = {
      color: { argb: 'FFFFFFFF' },
      bold: true,
    };
    cell.alignment = { horizontal: 'center' };
  });

  data.forEach(item => {
    const rowData = {};
    exportableColumns.forEach(col => {
      if (col.accessorFn) {
        rowData[col.accessorKey || col.id] = col.accessorFn(item);
      } else if (col.accessorKey) {
        rowData[col.accessorKey] = item[col.accessorKey];
      }
    });
    worksheet.addRow(rowData);
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  saveAs(blob, `${fileName}.xlsx`);
}

